import { render } from "./mhtk-module-injector.vue?vue&type=template&id=898b8a98&ts=true"
import script from "./mhtk-module-injector.vue?vue&type=script&lang=ts"
export * from "./mhtk-module-injector.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/workspace/t-public-workspace_release_0.5.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__